import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { useCallback } from 'react';
import { OutlineButton } from '@/components/ui/Button/OutlineButton';
import { CheckCircleOutlineGrayIcon } from '@/components/ui/SvgIcon/Static/SvgIconComponents';
import { Text } from '@/components/ui/Typography/Body/Text';
import { IconTextGroup } from '@/components/ui/Typography/IconText/IconTextGroup';
export const ViewRequestButton = (props) => {
    const { className = '', disabled = false, id, isDisclose, isDiscloseApproved, onClick: propOnClick, } = props;
    // クリック時に id 渡す
    const onClick = useCallback(() => {
        propOnClick(id);
    }, [id, propOnClick]);
    // 開示されてない場合
    if (!isDisclose && !isDiscloseApproved) {
        return (_jsx(OutlineButton, Object.assign({ className: clsx('md:h-[30px] lg:h-[40px] xl:h-[30px]', className), color: 'navy', disabled: disabled, isFull: true, onClick: onClick, size: 'md', textClassName: 'md:text-11 lg:text-13 xl:text-11' }, { children: "\u958B\u793A\u3059\u308B" })));
    }
    return (_jsxs(IconTextGroup, Object.assign({ className: clsx('justify-center', 'w-full', 'bg-white', 'border border-solid border-gray-400', 'rounded-md', 'h-[40px] md:h-[30px] lg:h-[40px] xl:h-[30px]', 'p-4', className) }, { children: [_jsx(CheckCircleOutlineGrayIcon, { size: 'sm' }), _jsx(Text, Object.assign({ className: 'md:text-11 lg:text-13 xl:text-11', color: 'textGray', size: 'sm' }, { children: isDisclose ? '公開済' : '開示済' }))] })));
};
